import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { TransactionSubType } from 'src/model/transactionSubType.model';

interface TransactionInterface {
  remark: string,
  amount: number,
  date: Date,
  subtype?: number
}

@Component({
    selector: 'app-add-multiple-transaction',
    templateUrl: './add-multiple-transaction.component.html',
    styleUrls: ['./add-multiple-transaction.component.scss'],
    standalone: false
})

export class AddMultipleTransactionComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);

  amount = 0;
  remark: string;
  subtype: number;
  date: Date = new Date();

  disabledSubmit = false;

  transactionList: TransactionInterface[] = [];
  subtypeList: TransactionSubType[] = [];

  @Input() paidByDuitLebih = false;
  @Output() passTransactionDetails = new EventEmitter<any>();

  ngOnInit(): void {
    this.getTransactionSubTypes();
  }

  getTransactionSubTypes() {
    let xhttp;

    xhttp = (this.paidByDuitLebih == true)
      ? this.restapi.getRequest(this.constructApi.getTransactionSubTypes(this.enums.EXTRAS))
      : this.restapi.getRequest(this.constructApi.getTransactionSubTypes(this.enums.EXPENSE));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);

          if (json.assignable == true)
            this.subtypeList.push(type);
        });
      }
    };
  }

  calculateTotalAmount() {
    let sum = 0;

    for (let i = 0; i < this.transactionList.length; i++) {
      sum += this.transactionList[i].amount;
    }

    return sum;
  }

  isInvalid() {
    const remarkNull = (this.remark == undefined || this.remark === '');
    const amountNull = (this.amount == undefined || this.amount == 0);
    const amountValid = isNaN(+this.amount)
    const dateNull = (this.date == undefined)

    return (dateNull || remarkNull || amountNull || amountValid);
  }

  getSubTypeName(id: number) {
    for (let i = 0; i < this.subtypeList.length; i++) {
      if (this.subtypeList[i].ID == id)
        return this.subtypeList[i].Name;
    }
  }

  addToList() {
    const transaction = { remark: this.remark, amount: this.amount, date: this.date, subtype: this.subtype }
    this.transactionList.push(transaction);
    this.cdr.detectChanges();

    this.resetValues();
    this.passTransactionDetails.emit(this.transactionList);
  }

  submit() {
    if (this.isInvalid()) {
      this.sharedService.openAlert('Please fill in all the fields!', ALERT_TYPE.DANGER)
    }
    else if (this.paidByDuitLebih == false && this.subtype == undefined)
      this.sharedService.openAlert('Please select subtype!', ALERT_TYPE.DANGER)
    else
      this.addToList();
  }

  reset() {
    this.activeModal.close();
    this.resetValues();
  }

  removeTransaction(i: number) {
    this.transactionList.splice(Number(i), 1);
    this.cdr.detectChanges();
    this.passTransactionDetails.emit(this.transactionList);
  }

  resetValues() {
    this.remark = undefined;
    this.amount = undefined;
    this.subtype = undefined;
  }
}
